function debounce(func: Function, delay: number): Function {

  let inDebounce: any;

  return function() {

    const args: IArguments = arguments;

    clearTimeout(inDebounce);

    inDebounce = setTimeout(() => func(args[0]), delay);
  }
}

export {
  debounce
}